<template>
  <h1 v-show="false">
    {{ h1Text }}
  </h1>
</template>

<script lang="ts" setup>
  const route = useRoute()
  // console.log('🍉 ~ GlobalH1Tag.vue:9 ~ route:', route)
  const MetaPageCode = computed(() => route.meta.pageCode)

  const h1Text = computed(() => {
    if (MetaPageCode.value === 'ERA.UC.HOME') {
      return isCn.value ? '杰西圈' : 'JCtrans'
    }
    if (MetaPageCode.value === 'ERA.UC.MEMBERSHIP') {
      return isCn.value
        ? '货代公司名录'
        : 'List of freight forwarding companies'
    }
    if (MetaPageCode.value === 'ERA.UC.MEMBERSHIP.BO') {
      return isCn.value ? '会员权益对比' : 'Benefits Overview'
    }
    if (MetaPageCode.value === 'ERA.UC.MEMBERSHIP.JCE') {
      return isCn.value ? 'JCtrans Elite' : 'JCtrans Elite Membership'
    }
    if (MetaPageCode.value === 'ERA.UC.MEMBERSHIP.JCP') {
      return isCn.value ? 'JCtrans Premium' : 'JCtrans Premium Membership'
    }
    if (MetaPageCode.value === 'ERA.UC.MEMBERSHIP.JCRI') {
      return isCn.value ? 'JCtrans Rising' : 'JCtrans Rising Membership'
    }
    if (MetaPageCode.value === 'ERA.UC.MEMBERSHIP.JCTP') {
      return isCn.value ? 'JCtrans Projects' : 'JCtrans Projects Membership'
    }
    if (MetaPageCode.value === 'ERA.UC.MEMBERSHIP.JCTD') {
      return isCn.value
        ? 'JCtrans Dangerous Goods'
        : 'JCtrans Dangerous Goods Membership'
    }
    if (MetaPageCode.value === 'ERA.UC.MEMBERSHIP.JCEC') {
      return isCn.value ? 'JCtrans eCommerce' : 'JCtrans eCommerce Membership'
    }
    if (MetaPageCode.value === 'ERA.UC.MEMBERSHIP.JCR') {
      return isCn.value ? 'JCtrans Railway' : 'JCtrans Railway Membership'
    }
    if (MetaPageCode.value === 'ERA.UC.MEMBERSHIP.JCV') {
      return isCn.value ? 'JCtrans Vendor' : 'JCtrans Vendor Membership'
    }
    if (MetaPageCode.value === 'ERA.UC.TOOLS.BLACK.BLACKLIST') {
      return isCn.value ? '风险名单' : 'Risk Member List'
    }
    if (MetaPageCode.value === 'ERA.UC.TOOLS.BLACK.SUSPENDLIST') {
      return isCn.value ? '暂停名单' : 'Suspended List'
    }
    if (MetaPageCode.value === 'ERA.UC.JoinUs') {
      return isCn.value ? '即刻链接全球货代' : 'Apply for JCtrans membership'
    }

    return ''
  })
  const { isCn } = useVipLogo()
</script>

<style></style>
